import { PageDS, Spacer, TabMenu, ToastContainerDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { VehiclesTab } from "./vehiclesTab";
import { DriversTab } from "./driversTab";
import { ElectrificationHeader } from "./header";
import "../../../i18n/i18n";
import { supportPhonesByCompanyGroupUuid } from "../../../constants/support";
import { selectManagersList } from "../users/usersSlice";
import { useAppSelector } from "../../../redux/hooks";

export const Electrification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const managers = useAppSelector(selectManagersList);

  const otherSupportPhones = useMemo(
    () =>
      managers && managers.length > 0 && managers[0].companyGroup
        ? supportPhonesByCompanyGroupUuid[managers[0].companyGroup]
        : undefined,
    [managers],
  );

  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "vehicles",
  );

  const tabs = [
    {
      name: "vehicles",
      title: t("electrification.tab.vehicles"),
    },
    {
      name: "drivers",
      title: t("electrification.tab.drivers"),
    },
  ];

  useEffect(() => {
    if (import.meta.env["VITE_TARGET_ENV"] === "production") {
      navigate("/home");
    }
  }, [navigate]);

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/electrification/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  return (
    <PageDS
      title={t("electrification.title")}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Spacer y={1.5} />
          <ElectrificationHeader />
          <Spacer y={1} />
        </>
      }
      supportButton={{
        showMail: !otherSupportPhones,
        otherPhones: otherSupportPhones,
      }}
    >
      <VehiclesTab />
      <DriversTab />
    </PageDS>
  );
};
